function IconUploadFile({ fillColor = "currentColor" }) {
  return (
    <svg width="50" height="50" viewBox="0 0 50 50" fill={fillColor} xmlns="http://www.w3.org/2000/svg">
      <path d="M23.8277 14.3011L19.1044 19.0244L17.8876 17.7903L24.9994 10.6765L32.1133 17.7904L30.8963 19.0264L26.171 14.3011L25.8572 13.9873V14.4311V32.2681H24.1415V14.4311V13.9873L23.8277 14.3011ZM37.6832 37.4998V31.3545H39.3989V39.3993H10.5998V31.3545H12.3155V37.4998V37.6837H12.4993H37.4994H37.6832V37.4998Z" fill="black" stroke="#F2F2F2" stroke-width="0.367647" />
    </svg>

  )
};

export default IconUploadFile;